/* @flow */
// typecheck: ignore file
import BoxBody from 'components/BoxBody.jsx';
import Copy from 'components/Copy.jsx';
import Dialog from 'components/Dialog.jsx';
import DialogButton from 'components/DialogButton.jsx';
import Link from 'components/Link.jsx';
import LinkConstants from 'constants/LinkConstants';
import React from 'react';

type Props = {
  hasChildren: boolean,
  onRequestHide?: () => any,
};

export default class DirectAddLegalDialog extends React.Component {
  props: Props;

  render() {
    return (
      <Dialog
        eventScreenName="DirectAddLegalDialog"
        {...this.props}
        title="Adding participants on Remind"
        size="small">
        <BoxBody>
          <Copy>
            <p>
              Here are a few guidelines to help you comply with the
              {' '}
              <Link target="_blank" href={LinkConstants.TERMS_OF_SERVICE}>Terms of Service</Link>
              {' '}
              of the Remind platform.
            </p>
            <ol>
              <li>
                <p>
                  Before adding anyone to a class, make sure you have their permission to send them
                  SMS messages and emails.
                </p>
              </li>
              <li>
                <p>
                  Use Remind only for non-commercial purposes.
                </p>
              </li>
              <li>
                <p>
                  Let participants know that normal text messaging rates may apply to messages they
                  receive.
                </p>
              </li>
              {this.props.hasChildren &&
                <li>
                  <p>
                    Remember to get parental consent for students under 13.
                    {' '}
                    <Link target="_blank" href={LinkConstants.PARENTAL_CONSENT}>Learn more</Link>
                  </p>
                </li>
              }
            </ol>
          </Copy>
          <DialogButton onClick={this.props.onRequestHide}>
            Got it
          </DialogButton>
        </BoxBody>
      </Dialog>
    );
  }
}



// WEBPACK FOOTER //
// ./src/groups/components/DirectAddLegalDialog.jsx